// Same-folder imports with `.ts`: the Node test runner can't resolve `@/`.
import { handoffDistinctIdParam, handoffFailedParam } from './inAppHandoff.ts';

/**
 * Where `SignUp` (`src/pages/signUp/SignUp.tsx`) sends the visitor after the
 * OAuth sign-up, carrying the page's query string on.
 *
 * `ph_id` and the `handoff` fallback marker are dropped. `PostHogProvider`
 * strips it from the window URL, but the router was created before that and
 * still has it, so without this the phone's PostHog id would end up in a
 * bookmarkable portal URL and a reload would bootstrap PostHog with it.
 *
 * The offer code stays: the callbacks (`GoogleSignInCallback.tsx`,
 * `LinkedInCallback.tsx`, `SlackSignInCallback.tsx`) need it to apply the
 * trial, then strip it so it doesn't linger in a shareable portal URL.
 */
export const getSignUpParams = (searchParams: URLSearchParams) => {
  const oauth = new URLSearchParams(searchParams);
  oauth.delete(handoffDistinctIdParam);
  oauth.delete(handoffFailedParam);

  const oauthQuery = oauth.toString();
  return {
    oauthReturnTo: oauthQuery ? `/?${oauthQuery}` : '/',
  };
};
